export default __webpack_public_path__ + "assets/blog_obj.c598bc055688333c0be2eaff18cd6302.svg";